import { type CardColors } from './types';

export const ReportCategoryNames = {
	ALL_CATEGORIES: 'all_categories',
	PRODUCTIVITY: 'productivity',
	UTILIZATION: 'utilization',
	REVENUE: 'revenue',
	COST: 'cost',
	PROFITABILITY: 'profitability',
	SALES: 'sales',
	EMPTY: '',
} as const;

export const ReportCategories: Map<
	string,
	{
		colors: CardColors;
		icon: string;
	}
> = new Map(
	Object.entries({
		[ReportCategoryNames.PRODUCTIVITY]: {
			colors: {
				backgroundColor: '#F6F0FD',
				textColor: '#3A1270',
				iconColor: '#7647B6',
				ctaColor: '#7647B6',
				circleColor: '#BF9DEE',
			},
			icon: 'icon-stopwatch-24',
		},
		[ReportCategoryNames.UTILIZATION]: {
			colors: {
				backgroundColor: '#EBF5FA',
				textColor: '#043159',
				iconColor: '#0469B5',
				ctaColor: '#0469B5',
				circleColor: '#5AB2ED',
			},
			icon: 'icon-pie-chart-24',
		},
		[ReportCategoryNames.REVENUE]: {
			colors: {
				backgroundColor: '#FCF1CD',
				textColor: '#79550C',
				iconColor: '#CBA00C',
				ctaColor: '#CBA00C',
				circleColor: '#FCDD45',
			},
			icon: 'icon-chart-filled-24',
		},
		[ReportCategoryNames.COST]: {
			colors: {
				backgroundColor: '#E3F1DF',
				textColor: '#145B39',
				iconColor: '#309C3F',
				ctaColor: '#309C3F',
				circleColor: '#85CE77',
			},
			icon: 'icon-coins-24',
		},
		[ReportCategoryNames.PROFITABILITY]: {
			colors: {
				backgroundColor: '#FCEBDB',
				textColor: '#85360D',
				iconColor: '#DA752C',
				ctaColor: '#DA752C',
				circleColor: '#F9AC67',
			},
			icon: 'icon-line-chart-24',
		},
		[ReportCategoryNames.SALES]: {
			colors: {
				backgroundColor: '#EEF1FF',
				textColor: '#101A58',
				iconColor: '#3E4C9E',
				ctaColor: '#3E4C9E',
				circleColor: '#8793DC',
			},
			icon: 'icon-board-24',
		},
	})
);
